// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__IFEoo","pagination":"carousel_pagination__S_3e3","customPagination":"carousel_customPagination__wI6u6"};